import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';

import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  // SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import ExtensionIcon from '@material-ui/icons/Extension';
import SearchIcon from '@material-ui/icons/Search';
import LayersIcon from '@material-ui/icons/Layers';
import CategoryIcon from '@material-ui/icons/Category';

import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
// import { SidebarSearchModal } from '@backstage/plugin-search';

// Unused icons
// import FolderIcon from '@material-ui/icons/Folder';
// import LibraryBooks from '@material-ui/icons/LibraryBooks';
// import HomeIcon from '@material-ui/icons/Home';
// import MapIcon from '@material-ui/icons/MyLocation';
// import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
// import MoneyIcon from '@material-ui/icons/MonetizationOn';
// import MenuIcon from '@material-ui/icons/Menu';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="search">
        <SidebarItem icon={SearchIcon} to="search" text="Search" />
        {/* <SidebarSearchModal /> */}
      </SidebarGroup>
      <SidebarDivider />
      {/* <SidebarGroup label="Menu" icon={<MenuIcon />}> */}
      {/* <SidebarItem icon={HomeIcon} to="/" text="Home" /> */}
      <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
      <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
      <SidebarItem icon={LayersIcon} to="explore" text="Explore" />

      {/* <SidebarItem icon={LibraryBooks} to="docs" text="Docs" /> */}
      <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
      {/* <SidebarDivider />
        <SidebarScrollWrapper>
          <SidebarItem icon={MoneyIcon} to="cost-insights" text="Cost Insights" />
          <SidebarItem icon={MapIcon} to="tech-radar" text="Tech Radar" />
        </SidebarScrollWrapper> */}
      {/* </SidebarGroup> */}
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
